export const onSaveDataTok = (dataToken) => {
	let vT = 'vencimientoToken';
	localStorage.setItem(vT, dataToken);
};
